/* 
 *  This file app-routing.module.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuardService } from './global/guard/auth-guard-service';
import { SuperUserResolverService } from './global/services/super-user.resolver.service';

export const routes: Routes = [
  { path: '', redirectTo: 'product-management/login', pathMatch: 'full' },
  { path: 'product-management/login', loadComponent: () => import('./modules/product-management-auth/product-management-auth.component').then(m => m.ProductManagementAuthComponent) },
  {
    path: 'product-management', loadChildren: () => import('./modules/product-management/product-management.module').then(m => m.ProductManagementModule), canLoad: [AuthGuardService], resolve: {
      superUser: SuperUserResolverService
    }
  },
  { path: 'customer/login', loadComponent: () => import('./modules/customer-auth/customer-auth.component').then(m => m.CustomerAuthComponent) },
  { path: 'customer/signup', loadComponent: () => import('./modules/customer-auth/customer-auth.component').then(m => m.CustomerAuthComponent) },
  {
    path: 'customer-setup',
    loadComponent: () => import('./modules/custome-setup/customer-setup.component').then(m => m.CustomerSetupComponent),
    canLoad: [AuthGuardService], resolve: {
      superUser: SuperUserResolverService
    },
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', loadComponent: () => import('./modules/product-management/setup/customer/customer.component').then(m => m.CustomerComponent) },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }